import React, { useCallback } from "react";

import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FilterTypeEnum } from "@/enum/filters";
import { useFilters } from "@/providers/FiltersProvider";
import { IMainFilterChildren } from "@/types/Filters";

interface IFilterItem {
    data: IMainFilterChildren
}
function FilterItem({ data }: IFilterItem) {
    const { tempFilters, setSelectedFilterItem } = useFilters();

    const handleSelect = useCallback(() => {
        setSelectedFilterItem(data);
    }, [data, setSelectedFilterItem]);

    const getSelectedFilterTitle = useCallback(() => {
        // console.log("tempFilters:-", tempFilters);
        switch (data.type) {
            case FilterTypeEnum.RADIO_SELECT:
            {
                return tempFilters?.[data.id]?.data?.[0]?.label;
            }
            case FilterTypeEnum.MULTI_SELECT_CHECKBOX:
            case FilterTypeEnum.NESTED_MULTI_SELECT_CHECKBOX:
            {
                const d = tempFilters?.[data.id];
                if (d?.data?.length > 1) {
                    return "Multiple selected";
                }
                return tempFilters?.[data.id]?.data?.[0]?.label;
            }
            default:
                return null;
        }
    }, [data.id, data.type, tempFilters]);

    return (
        <div className='filterListItem' onClick={handleSelect}>
            <div className='title'>
                {data.name}
            </div>
            <div className='action'>
                <div className="selectedValue greenText">{getSelectedFilterTitle()}</div>
                <FontAwesomeIcon icon={faChevronRight} />
            </div>
        </div>
    );
}

export default FilterItem;
